import { ConfiguracionFicha } from 'src/app/compartido/ficha/utilidades/ficha.models';
import { TipoCampoFormulario } from 'src/app/compartido/formulario/utilidades/formulario.models';
import {
  ConfiguracionTablaAsincrona,
  TipoColumnaTabla,
} from 'src/app/compartido/tabla/utilidades/tabla.models';
import { Icono } from 'src/app/compartido/utilidades/compartido.static';
import { EstadoOrden } from 'src/app/ordenes/utilidades/ordenes.models';

/* Configuración de la ficha de imprimir etiquetas */
export const CONFIGURACION_FICHA_IMPRIMIR_ETIQUETAS: ConfiguracionFicha = {
  header: { titulo: 'Imprimir Etiquetas', icono: Icono.ETIQUETAS },
  maxWidth: 1200,
};

/* Configuración de la tabla de imprimir etiquetas */
export const CONFIGURACION_TABLA_IMPRIMIR_ETIQUETAS: ConfiguracionTablaAsincrona =
  {
    columnas: [
      {
        nombre: 'Impresa',
        slug: 'etiqueta_generada',
        tipo: TipoColumnaTabla.BOOLEANO,
      },
      { nombre: 'ID', slug: 'id' },
      { nombre: 'Título', slug: 'titulo' },
      { nombre: 'N° Referencia', slug: 'referencia' },
    ],
    filtros: [
      {
        nombre: 'Organización',
        slug: 'organizacion',
        tipo: TipoCampoFormulario.NUMERO,
        oculto: true,
      },
      {
        nombre: 'Punto de Origen',
        slug: 'origen',
        tipo: TipoCampoFormulario.OPCION_MULTIPLE,
        opciones: [],
      },
      {
        nombre: 'Estados',
        slug: 'estados',
        tipo: TipoCampoFormulario.TEXTO,
        oculto: true,
        valor: EstadoOrden.PREPARADA + ',' + EstadoOrden.RECOGIDA,
      },
      {
        nombre: 'Fecha Preparación',
        slug: 'fecha_preparacion',
        tipo: TipoCampoFormulario.FECHA,
        oculto: true,
      },
      {
        nombre: 'Autor Preparación',
        slug: 'autor_preparacion',
        tipo: TipoCampoFormulario.OPCION_MULTIPLE,
        opciones: [],
      },
      {
        nombre: 'Sin Domicilio',
        slug: 'sin_domicilio',
        tipo: TipoCampoFormulario.BOOLEANO,
        valor: false,
        oculto: true,
      },
      {
        nombre: 'Impresa',
        slug: 'etiqueta_generada',
        tipo: TipoCampoFormulario.BOOLEANO,
      },
    ],
    busqueda: true,
    botones: [
      {
        nombre: 'Imprimir Todas',
        slug: 'etiquetas',
        icono: Icono.ETIQUETAS,
      },
      {
        nombre: 'Descargar Órdenes',
        slug: 'etiqueta',
        icono: Icono.DESCARGAR,
      },
    ],
    acciones: [
      {
        nombre: 'Imprimir Etiqueta',
        slug: 'etiqueta',
        icono: Icono.ETIQUETAS,
      },
    ],
    omitirCargaInicial: true,
    widthFiltros: 220,
  };
